import WorkflowCard from './WorkflowCard';

export default WorkflowCard;
